export const PUBLICATION_STATUS = Object.freeze({
  PUBLISHED: 'published',
  MISSING: 'missing',
  BLOCKED: 'blocked',
})

export const LEGAL_GROUPS = Object.freeze([
  Object.freeze({ key: 'about', title: 'Hakkımızda', order: 1 }),
  Object.freeze({ key: 'legislation', title: 'Mevzuat', order: 2 }),
  Object.freeze({ key: 'privacy', title: 'Gizlilik ve Kişisel Veri Koruması', order: 3 }),
])

export const LEGAL_DOCUMENTS = Object.freeze([
  Object.freeze({
    key: 'membership-agreement',
    slug: 'diko-uyelik-sozlesmesi',
    title: 'DİKO Üyelik Sözleşmesi',
    group: 'about',
    groupOrder: 1,
    documentOrder: 1,
    publicationStatus: PUBLICATION_STATUS.PUBLISHED,
    interactionType: 'acceptance',
    contentComponent: 'MembershipAgreement',
    sourceFile: 'client/src/libs/privacy.js + DİKO SÖZLEŞMESİ 8. MADDE DEĞİŞİKLİĞİ-REVİZYON.docx',
    sourceSha256: '4f5045498389d8c6dc8b1c16922ed2ecd79205b2f8132494e0f9fc5829059ac2',
    version: null,
    effectiveAt: null,
  }),
  Object.freeze({
    key: 'cancellation-and-refund',
    slug: 'uyelik-iptal-fesih-iade-kosullari',
    title: 'Üyelik İptal ve İade Koşulları',
    group: 'about',
    groupOrder: 1,
    documentOrder: 2,
    publicationStatus: PUBLICATION_STATUS.PUBLISHED,
    interactionType: 'purchase-acceptance',
    contentComponent: 'WordDocument',
    sourceType: 'docx',
    sourceFile: 'DİKO ABONELİK İPTAL REVİZE.docx',
    sourceSha256: '83756da50627da26b4ad84a49f907fa4309b89a43147a131490f290eb98f395f',
  }),
  Object.freeze({
    key: 'kvkk-law',
    slug: 'kisisel-verileri-koruma-kanunu',
    title: 'Kişisel Verileri Koruma Kanunu',
    group: 'legislation',
    groupOrder: 2,
    documentOrder: 1,
    publicationStatus: PUBLICATION_STATUS.PUBLISHED,
    interactionType: 'information',
    contentComponent: 'SourceDocument',
    sourceType: 'pdf',
    sourceFile: 'KİŞİSEL VERİLERİ KORUMA KANUNU.pdf',
    sourceSha256: '1ad27253b0068d4c3d991b92b68c6bc1104439430160f4350a3f04fbb211f2b5',
  }),
  Object.freeze({
    key: 'erasure-regulation',
    slug: 'kisisel-verilerin-silinmesi-yok-edilmesi-anonim-hale-getirilmesi',
    title: 'Kişisel Verilerin Silinmesi, Yok Edilmesi veya Anonim Hale Getirilmesi Hakkında Yönetmelik',
    group: 'legislation',
    groupOrder: 2,
    documentOrder: 2,
    publicationStatus: PUBLICATION_STATUS.PUBLISHED,
    interactionType: 'information',
    contentComponent: 'SourceDocument',
    sourceType: 'pdf',
    sourceFile: 'KİŞİSEL VERİLERİN SİLİNMESİ YÖNETMELİK.pdf',
    sourceSha256: '0bd189df5157d84e3fb261b1e0aef47b0d1274649bd1e2bbd062a5b6fd98abbb',
  }),
  Object.freeze({
    key: 'controller-application-communique',
    slug: 'veri-sorumlusuna-basvuru-usul-ve-esaslari',
    title: 'Veri Sorumlusuna Başvuru Usul ve Esasları Hakkında Tebliğ',
    group: 'legislation',
    groupOrder: 2,
    documentOrder: 3,
    publicationStatus: PUBLICATION_STATUS.PUBLISHED,
    interactionType: 'information',
    contentComponent: 'SourceDocument',
    sourceType: 'pdf',
    sourceFile: 'VERİ SORUMLUSUNA BAŞVURU TEBLİĞ.pdf',
    sourceSha256: 'e0d85fd63de986b80525aa16b5a0628764e73b5f34d7337bc3ec71951a115fab',
  }),
  Object.freeze({
    key: 'privacy-policy',
    slug: 'gizlilik-politikasi',
    title: 'Gizlilik Politikası',
    group: 'privacy',
    groupOrder: 3,
    documentOrder: 1,
    publicationStatus: PUBLICATION_STATUS.MISSING,
    interactionType: 'information',
    unavailableReason: 'Hukuk danışmanı tarafından belirtilen kaynak dosya bekleniyor.',
  }),
  Object.freeze({
    key: 'cookie-notice',
    slug: 'cerez-aydinlatma-metni',
    title: 'Çerezlere Dair Aydınlatma Metni',
    group: 'privacy',
    groupOrder: 3,
    documentOrder: 2,
    publicationStatus: PUBLICATION_STATUS.PUBLISHED,
    interactionType: 'information',
    contentComponent: 'WordDocument',
    sourceType: 'docx',
    sourceFile: 'ÇEREZLERE DAİR AYDINLATMA METNİ-DİKO.docx',
    sourceSha256: '413320db27015a5ce98da2525741e9a39ef04aef0ba391e784ac2447d41a2716',
  }),
  Object.freeze({
    key: 'retention-and-destruction-policy',
    slug: 'kisisel-veri-saklama-ve-imha-politikasi',
    title: 'DİKO Kişisel Veri Saklama ve İmha Politikası',
    group: 'privacy',
    groupOrder: 3,
    documentOrder: 3,
    publicationStatus: PUBLICATION_STATUS.MISSING,
    interactionType: 'information',
    unavailableReason: 'Hukuk danışmanı tarafından belirtilen kaynak dosya bekleniyor.',
  }),
  Object.freeze({
    key: 'kvkk-notice',
    slug: 'kvkk-aydinlatma-metni',
    title: 'KVKK Aydınlatma Metni',
    group: 'privacy',
    groupOrder: 3,
    documentOrder: 4,
    publicationStatus: PUBLICATION_STATUS.PUBLISHED,
    interactionType: 'acknowledgement',
    contentComponent: 'WordDocument',
    sourceType: 'docx',
    sourceFile: 'KVKK Aydınlatma Metni.docx',
    sourceSha256: '9fbf4ae188826b74f00ca38af0ae0b1d235b5d34eaf6b812dec7c21940d290f0',
  }),
  Object.freeze({
    key: 'marketing-consent',
    slug: 'pazarlama-acik-riza-metni',
    title: 'Pazarlama Amaçlı Kişisel Veri İşleme Açık Rıza Metni',
    group: 'privacy',
    groupOrder: 3,
    documentOrder: 5,
    publicationStatus: PUBLICATION_STATUS.PUBLISHED,
    interactionType: 'optional-consent',
    contentComponent: 'MarketingConsent',
    sourceFile: 'DİKO Pazarlama Amaçlı Kişisel Veri İşleme Açık Rıza Metni.docx',
    sourceSha256: '460208ca0cee2c3fd9d54f5e702dadea92faea5287b62c3ef7a558bb50d37956',
    version: null,
    effectiveAt: null,
  }),
  Object.freeze({
    key: 'data-subject-application-form',
    slug: 'kisisel-veri-sahibi-basvuru-formu',
    title: 'Kişisel Veri Sahibi Başvuru Formu',
    group: 'privacy',
    groupOrder: 3,
    documentOrder: 6,
    publicationStatus: PUBLICATION_STATUS.PUBLISHED,
    interactionType: 'information',
    contentComponent: 'WordDocument',
    sourceType: 'docx',
    sourceFile: 'KVKK BAŞVURU FORMU.docx',
    sourceSha256: '2142175c818a5f8cc145703faf20a0c1c1295ba8aec2bba3fe4fd259204af62c',
  }),
])

export const getLegalDocumentBySlug = slug => LEGAL_DOCUMENTS.find(document => document.slug === slug)

export const getLegalDocumentByKey = key => LEGAL_DOCUMENTS.find(document => document.key === key)

export const isPublishedLegalDocument = document => Boolean(
  document && document.publicationStatus === PUBLICATION_STATUS.PUBLISHED,
)

export const getDocumentsForGroup = groupKey => LEGAL_DOCUMENTS
  .filter(document => document.group === groupKey)
  .sort((left, right) => left.documentOrder - right.documentOrder)
